import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    deleteTagMutation: gql`
        mutation DeleteTag($tagID: String!) {
            deleteTag(tagID: $tagID) {
                _
            }
        }
    `,
};
